import Vue from 'vue'
import budgetTransformer from '../../../transformers/budgetReport/budgetTransformer'
import moment from 'moment'

function urlParamsTransformer(options) {
  const from = options.from ? moment(options.from).format('YYYY/MM/DD'): null
  const to = options.to ? moment(options.to).format('YYYY/MM/DD'): null
  const search_text = !!options.searchQuery ? options.searchQuery : undefined

  return {
    page: options.page,
    size: options.pageSize,
    highway: options.highway,
    text: search_text,
    from,
    to
  }

}

export default (options) => {
  let config
  let urlParams
  let url = `purchase/budget/report/`

  urlParams = urlParamsTransformer(options)

  if (urlParams) {
    config  = {
       params: urlParams,
     }
  }

  return Vue.$http.get(url, config)
    .then(response => {
      const paginationInfo = {...response.data, results: null}
      const results = response.data.results
      const sinisters = budgetTransformer.fetchCollection(results)
      return {sinisters, paginationInfo}
    })

}



// WEBPACK FOOTER //
// ./src/services/reports/budgetReport/budgetService.js